var _path, _path2, _path3, _path4, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditApplication = function SvgEditApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#editApplication_svg__a)",
    d: "M44.82 88H20.5C9.46 88 .5 79.04.5 68V20c0-11.04 8.96-20 20-20h20v20c0 6.6 5.4 12 12 12h20v8c-17.64 0-32 14.36-32 32 0 5.84 1.6 11.28 4.32 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#editApplication_svg__b)",
    d: "M48.5.6v19.36c0 2.2 1.8 4 4 4h19.32c-.56-1.76-1.48-3.36-2.8-4.68L53.42 3.52C52.02 2.16 50.34 1.2 48.5.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#editApplication_svg__c)",
    d: "M48.5 72c0-13.24 10.76-24 24-24s24 10.76 24 24-10.76 24-24 24-24-10.76-24-24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70 62c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 17,
    x: 70,
    y: 67.5,
    fill: "#fff",
    rx: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "editApplication_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-60.79515 79.69822 -71.4781 -54.5247 67.022 5.729)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "editApplication_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.946 34.561 16.308)scale(28.9019 26.8076)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editApplication_svg__c",
    x1: 72.5,
    x2: 72.5,
    y1: 44.294,
    y2: 113.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgEditApplication;